import { FunctionComponent } from 'react'
import { HeroSVGProps } from '@/components/HeroIcons/icon-types'
import { useTheme } from '@emotion/react'

const ArrowDown: FunctionComponent<HeroSVGProps> = ({
  themeColor,
  ...rest
}) => {
  const theme = useTheme()
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.23123 9.23964C7.53954 8.92012 8.03941 8.92012 8.34772 9.23964L12 13.0247L15.6523 9.23964C15.9606 8.92012 16.4605 8.92012 16.7688 9.23964C17.0771 9.55916 17.0771 10.0772 16.7688 10.3967L12.5582 14.7604C12.2499 15.0799 11.7501 15.0799 11.4418 14.7604L7.23123 10.3967C6.92292 10.0772 6.92292 9.55916 7.23123 9.23964Z"
        fill={theme.colors[themeColor[0]][themeColor[1]]}
      />
    </svg>
  )
}

export default ArrowDown
